import React,{useState,useEffect} from 'react'
import { Grid, Box } from "@mui/material";

  // antd
  import { Button, Card, Flex ,} from "antd";
  // constant
  import userRole, { cardContentStyle } from "constants/userRole";
  //antd icons
  import { PlusOutlined,DeleteOutlined , SaveOutlined, LeftCircleOutlined} from "@ant-design/icons";
  import { useGetUserByIdQuery } from 'api/userApi';  
  //antd
  import { Radio, Typography } from 'antd';
  const { Text, Link , Title} = Typography;


  
  
  import { Breadcrumb } from 'antd';
import PestThresholdModal from 'components/pest-threshold/modal/PestThresholdModal';

const Header = ({breadcrumbItems,  handleAddButtonClick,handleUpdateButtonClick ,description, pestThreshold, WeatherStation, }) => {
  const [isEditable, setIsEditable] = useState(false);
  const [role, setRole] = useState();
  const user = JSON.parse(localStorage.getItem("user"));
  const userDetailsQuery = useGetUserByIdQuery(user?.uId)
  const [userDetails,setUserDetails] = useState([])

  useEffect(() => {
    if (userDetailsQuery?.data){
      setRole(userDetailsQuery?.data ? userDetailsQuery?.data?.uRole : null);
      setUserDetails(userDetailsQuery?.data)
      setIsEditable(
        userDetailsQuery?.data?.data?.uRole === userRole.ADMIN || userDetailsQuery?.data?.data?.uRole === userRole.MODERATOR ? true : false
      );
    }
  }, [userDetailsQuery.status]);
  return (
   <Grid spacing={4} item container>
       <Grid item lg={12} xs={12}>
       <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box flexGrow={2}>
          
      <Breadcrumb separator=">" items={breadcrumbItems} />
   
              </Box>
              <Box alignSelf="flex-end">
                {isEditable && WeatherStation? (
                  <>

                 <Button
                    onClick={handleUpdateButtonClick}
                    type="primary"
                    icon={<PlusOutlined />}
                  >
                    {'Update Pest Threshold'}
                  </Button> 
                    
                  <PestThresholdModal/>
                  </>
                
                ) : (
                  ""
                )}
              </Box>
            </Box>
       </Grid>
      <Grid item>
      <Flex >
      <Title  level={4} mark>
               {description}
      </Title>
            </Flex>
      
      </Grid>
       
          </Grid>
  )
}

export default Header